var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin":"50px 150px"}},[_c('iframe',{staticStyle:{"width":"100%","height":"85vh"},attrs:{"src":"https://plantpp.ai4breeding.com/profile/upload/file/help.pdf","frameborder":"0"}})])])
}]

export { render, staticRenderFns }